const state = {
    layers: '1',
    hoverLayer: null,
}

// getters
const getters = {

}

// actions
const actions = {

}

// mutations
const mutations = {
  setLayers(state, layers) {
    state.layers = layers
  },
  setHoverLayer(state, hoverLayer) {
      state.hoverLayer = hoverLayer
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}